if($('footer#footer').length){
    if(!$('body.type-detail').length){
        $('footer#footer').after($('footer#footer .mobileSuNavigation'))
    }
}

$('html').on('click', '.newLogin', function(){
    $('body').addClass('user-action-visible login-window-visible')
})